import React from 'react'
import style from '../scss/components/SeminarImages.module.scss'
import { Fade } from "react-awesome-reveal"
import pic1 from '../assets/seminar/pic1.jpg'
import pic2 from '../assets/seminar/pic2.jpg'
import pic3 from '../assets/seminar/pic3.jpg'
import pic4 from '../assets/seminar/pic4.jpg'
import pic5 from '../assets/seminar/pic5.jpg'
import pic6 from '../assets/seminar/pic6.jpg'

const SeminarImages = () => {
    return (
        <Fade triggerOnce={true}>
            <div className={style.Container}>
                <div className={style.Images}>
                    <div className={style.Image}>
                        <img src={pic1} alt={''}/>
                    </div>
                    <div className={style.Image}>
                        <img src={pic6} alt={''}/>
                    </div>
                    <div className={style.Image}>
                        <img src={pic3} alt={''}/>
                    </div>
                    <div className={style.Image}>
                        <img src={pic4} alt={''}/>
                    </div>
                    <div className={style.Image}>
                        <img src={pic5} alt={''}/>
                    </div>
                    <div className={style.Image}>
                        <img src={pic2} alt={''}/>
                    </div>
                </div>
            </div>
        </Fade>
    )
}

export default SeminarImages
